<div class="card">
    <div class="header">
        <div class="header-text">{{headerText}}</div>
        <app-base-toggle-switch [checked]="checked" (toggled)="handleToggle()"></app-base-toggle-switch>
    </div>
    <div class="body">
        <div class="descriptive-text">{{descriptiveText}}</div>
    </div>
</div>
